import React, { useEffect } from 'react'
import SectionHeader from '../Components/SectionHeader/SectionHeader'
import { useTranslation } from 'react-i18next';
import TextCaption from '../Components/TextCaption/TextCaption';
import { buildQueries } from '@testing-library/react';

const TermsAndConditions = () => {
    const { i18n, t } = useTranslation();

    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to top on component mount
    }, []);

    return (
        <div>
            <SectionHeader title="TERMS AND CONDITIONS"
                subtitle={"Promotion"}
            />

            <div
                style={{
                    maxWidth: 920,
                    margin: '0 auto',
                    padding: '8px 16px 24px',
                    textAlign: 'center',
                }}
            >
                <div
                    className="terms-and-conditions-red-title"
                    style={{
                        color: '#c00000',
                        fontWeight: 700,
                        fontSize: 34,
                        lineHeight: 1.2,
                        marginBottom: 18,
                    }}
                >
                    {t('“Scratch & Win – Official Spain 2026 T-Shirt”')}
                </div>

                <div
                    style={{
                        height: 3,
                        width: '70%',
                        margin: '0 auto 56px',
                        backgroundColor: '#c00000',
                    }}
                />

                <div
                    className="terms-and-conditions-red-subtitle"
                    style={{
                        color: '#2b2b2b',
                        fontWeight: 700,
                        fontSize: 18,
                        marginBottom: 18,
                    }}
                >
                    {t('Participating Branches:')}
                </div>

                <div
                    className="terms-and-conditions-red-subtitle"
                    style={{
                        color: '#666',
                        fontWeight: 500,
                        fontSize: 20,
                        marginBottom: 34,
                    }}
                >
                    Fuenlabrada &nbsp; · &nbsp; Alcalá de Henares
                </div>

                <div
                    className="terms-and-conditions-red-subtitle"
                    style={{
                        color: '#2b2b2b',
                        fontWeight: 700,
                        fontSize: 18,
                    }}
                >
                    {t('Period: April 15 –  June 15, 2026')}
                </div>
            </div>

            <TextCaption subtitle={"1. Organizing Company"}
                paragraph={"This promotion is organized by HANSA-FLEX Ibérica, at its branches in Fuenlabrada and Alcalá de Henares (hereinafter, “the Organizer”)."} />

            <TextCaption subtitle={"2. Geographic Scope"}
                paragraph={"The promotion will be valid exclusively at the following branches:"}
                bulletPoints={["Fuenlabrada", "Alcalá de Henares"]}
            />

            <TextCaption subtitle={"3. Timeframe"}
                paragraph={"The promotion will be valid for purchases made at the counter between April 15, 2026, and June 15, 2026, both dates inclusive."} />


            <TextCaption subtitle={"4. Eligibility Requirements"}
                bulletPoints={[
                    "All individuals who make purchases exceeding €120 (excluding VAT) are eligible to participate.",
                    "Each valid invoice will generate a single entry, regardless of the total amount of the invoice.",
                    "If the invoice amount significantly exceeds €120, it will still count as a single entry.",
                    "There is no limit on the number of entries per customer, provided they are separate invoices that meet the minimum amount requirement.",
                    "In the event of full or partial payment of an invoice associated with the delivery of a “scratch-off ticket,” the amount paid will be deducted from the total purchase amount. If, after this adjustment, the resulting amount does not reach the minimum of €120 (excluding VAT), the entry will no longer be valid."
                ]}
            />

            <TextCaption subtitle={"5. Promotion Rules"}
                bulletPoints={[
                    "For each valid receipt, the customer will receive a “Scratch-and-Win” card at the counter at the time of purchase.",
                    "The customer will find out immediately if they have won.",
                    "The card will be given exclusively to the person making the purchase and only at the time of the transaction.",
                    "Cards will not be issued retroactively for previous purchases.",
                    "The card must be kept in good condition to claim the prize.",
                    "The Organizer may verify the authenticity of the card before delivering the prize."
                ]}
            />

            <TextCaption subtitle={"6. Prize"}
                paragraph={["One (1) Official Spain 2026 Home Kit T-shirt – player version, personalized, corresponding to the model worn by professional soccer players in official competition.",
                    "The jersey will be purchased through the current official supplier of the Spanish National Team, guaranteeing that it is an original and authentic product."]}
            />

            <TextCaption
                paragraph={["The jersey will be purchased through the current official supplier of the Spanish National Team, guaranteeing that it is an original and authentic product."]}
            />

            <TextCaption paragraph={"Prize Terms:"}
                bulletPoints={[
                    "Size is subject to availability.",
                    "Personalization is subject to the options available from the official supplier.",
                    "The prize is personal and non-transferable.",
                    "It cannot be exchanged for cash or any other product."
                ]}
            />


            <TextCaption subtitle={"7. Prize Delivery"}
                bulletPoints={[
                    "The prize will be delivered within approximately 7 business days of the winner’s validation, subject to the official supplier’s availability. The specific delivery date will be agreed upon in advance with the winner.",
                    "Delivery will take place at the location where the purchase was made."
                ]}
            />

            <TextCaption
                paragraph={"To ensure the transparency and reliability of the promotion, the winner may be asked, to the extent possible, to have a photograph taken at the time of prize delivery. This image may be displayed on the internal screen or bulletin board of the corresponding branch as evidence of prize delivery. In any case, publication of the image will be subject to the winner’s prior and express consent."}
            />

            <TextCaption subtitle={"8. Data Protection (GDPR)"}
                paragraph={"In compliance with Regulation (EU) 2016/679 of the European Parliament and of the Council (GDPR) and current Spanish data protection regulations:"}
                bulletPoints={["The personal data provided will be processed by the Organization for the sole purpose of managing this promotion and awarding the prize.",
                    "The legal basis for the processing will be the execution of the promotion and the consent of the data subject when necessary (for example, for the taking and publication of images).",
                    "The data will not be transferred to third parties, unless required by law.",
                    "The data will be retained only for as long as necessary to manage the promotion.",
                    "Participants may exercise their rights of access, rectification, erasure, restriction, objection, and data portability by submitting a written request to the Organization."]}
            />

            <TextCaption paragraph={"Participation in the promotion implies acceptance of the data processing as described in these terms and conditions."} />

            <TextCaption subtitle={"9. Limitations"}
                bulletPoints={[
                    "This promotion is not sponsored, endorsed, or administered by any federation, sports organization, or brand associated with the Spanish National Team.",
                    "The Organization is not responsible for any modifications to the product made by the official manufacturer.",
                    "In the event of unavailability of a size or stock, and after a reasonable waiting period, the Organization may consider issuing a voucher for the equivalent value of the official brand jersey."
                ]}
            />

            <TextCaption subtitle={"10. Modification or Cancellation"}
                paragraph={"The Organization reserves the right to modify, suspend, or cancel the promotion for just cause or due to force majeure."}
            />
            <TextCaption subtitle={"11. Acceptance of the Terms and Conditions"}
                paragraph={"Participation in the promotion implies full acceptance of these terms and conditions."}
            />


        </div>
    )
}

export default TermsAndConditions